import * as l from "react";
const v = (e) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "TM_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ l.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ l.createElement("g", { mask: "url(#TM_svg__a)" }, /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#29C470"
    }
  ), /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "TM_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ l.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ l.createElement("g", { mask: "url(#TM_svg__b)" }, /* @__PURE__ */ l.createElement("path", { fill: "#C51918", d: "M2-.323h10V26H2z" }), /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "TM_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 2,
      y: -1,
      width: 10,
      height: 27
    },
    /* @__PURE__ */ l.createElement("path", { fill: "#fff", d: "M2-.323h10V26H2z" })
  ), /* @__PURE__ */ l.createElement("g", { mask: "url(#TM_svg__c)" }, /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.595.906l-.546.701L2 1.56l.53-.681V.74l.002-.013.061-.19-.037-.065-.313.312.603-.938v.32l.115.105.276-.483-.277-.465-.2.154.081.163-.055.039-.452-.755.288.196.05-.073-.275-.28.122-.135-.403-.588L2.168-2l.438.64-.113.125.269.274-.124.18-.083-.057.158.263.265-.204.338.567-.34.593L2.78.203V.075l-.198.308.084.147-.07.218v.158zM2.05 6.63l.546-.702V5.77l.071-.218-.084-.147.198-.307v.128l.197.177.339-.592-.338-.567-.265.204-.158-.263.083.056.124-.18-.27-.274.114-.125-.438-.64-.052.046.403.587-.122.135.275.28-.05.074-.288-.197.452.755.055-.039-.08-.163.2-.153.276.465-.276.482-.115-.104v-.32l-.603.938.313-.313.037.066-.061.19-.002.013V5.9L2 6.581l.05.049zm.546 3.878l-.546.702L2 11.16l.53-.68v-.137l.002-.013.061-.19-.037-.066-.313.313.603-.938v.32l.115.105.276-.483-.277-.465-.2.154.081.162-.055.04-.452-.756.288.197.05-.074-.275-.28.122-.135-.403-.587.052-.045.438.64-.113.125.269.274-.124.179-.083-.056.158.263.265-.204.338.567-.34.592-.196-.177v-.128l-.198.308.084.146-.07.218v.158zm-.546 5.355l.546-.701v-.158l.071-.218-.084-.147.198-.308v.128l.197.178.339-.593-.338-.567-.265.204-.158-.263.083.056.124-.18-.27-.273.114-.125-.438-.64-.052.045.403.588-.122.134.275.28-.05.074-.288-.197.452.755.055-.038-.08-.163.2-.154.276.465-.276.483-.115-.104v-.321l-.603.938.313-.312.037.066-.061.19-.002.012v.137l-.53.68.05.05zm0 4.137l.546-.702v-.158l.071-.218-.084-.146.198-.308v.128l.197.177.339-.592-.338-.567-.265.204-.158-.263.083.056.124-.18-.27-.273.114-.126-.438-.64-.052.046.403.588-.122.134.275.28-.05.074-.288-.197.452.755.055-.038-.08-.163.2-.154.276.465-.276.483-.115-.105v-.32l-.603.938.313-.313.037.066-.061.19-.002.013v.136l-.53.681.05.049zm9.902 0l-.546-.702v-.158l-.071-.218.084-.146-.198-.308v.128l-.197.177-.339-.592.338-.567.265.204.158-.263-.083.056-.124-.18.27-.273-.114-.126.438-.64.052.046-.403.588.122.134-.275.28.05.074.288-.197-.452.755-.055-.038.08-.163-.2-.154-.276.465.276.483.115-.105v-.32l.603.938-.313-.313-.037.066.061.19.002.013v.136l.53.681-.05.049zm-.546-4.838l.546.701.049-.048-.53-.681v-.137l-.002-.013-.061-.19.037-.065.313.312-.603-.938v.32l-.115.105-.276-.483.277-.465.2.154-.081.163.055.038.452-.755-.288.197-.05-.073.275-.281-.122-.134.403-.588-.052-.045-.438.64.113.125-.269.274.124.18.083-.057-.158.263-.265-.204-.338.567.34.593.196-.178v-.128l.198.308-.084.147.07.218v.158zm.546-3.952l-.546-.702v-.158l-.071-.218.084-.146-.198-.308v.128l-.197.177-.339-.592.338-.567.265.204.158-.263-.083.056-.124-.18.27-.273-.114-.126.438-.64.052.046-.403.587.122.135-.275.28.05.074.288-.197-.452.755-.055-.039.08-.162-.2-.154-.276.465.276.483.115-.105v-.32l.603.938-.313-.313-.037.066.061.19.002.013v.136l.53.681-.05.049zm-.546-5.282l.546.702L12 6.58l-.53-.68v-.137l-.002-.013-.061-.19.037-.066.313.313-.603-.938v.32l-.115.104-.276-.482.277-.465.2.153-.081.163.055.039.452-.755-.288.197-.05-.074.275-.28-.122-.135.403-.587-.052-.046-.438.64.113.125-.269.274.124.18.083-.056-.158.263-.265-.204-.338.567.34.592.196-.177v-.128l.198.307-.084.147.07.218v.158zm.546-4.32l-.546-.702V.748L11.334.53l.084-.147-.198-.308v.128l-.197.178-.339-.593.338-.567.265.204.158-.263-.083.056-.124-.18.27-.273-.114-.125.438-.64.052.045-.403.588.122.134-.275.28.05.074.288-.196-.452.755-.055-.04.08-.162-.2-.154-.276.465.276.483.115-.104v-.32l.603.937-.313-.312-.037.066.061.19.002.012v.137l.53.68-.05.05z",
      fill: "#E8AA00"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.307 14.565H8.86v.364h.354v.292h.425v.948h-.425v.291H8.86v.292H7.349l-.419.372-.42-.372H5.107v-.292h-.353v-.291H4.4v-.948h.354v-.292h.353v-.364h1.444l.38-.335.376.335z",
      fill: "#389F5D"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M8.86 14.565h.25v-.25h-.25v.25zm-1.553 0l-.166.186.071.064h.095v-.25zm1.553.364h-.25v.25h.25v-.25zm.354 0h.25v-.25h-.25v.25zm0 .292h-.25v.25h.25v-.25zm.425 0h.25v-.25h-.25v.25zm0 .948v.25h.25v-.25h-.25zm-.425 0v-.25h-.25v.25h.25zm0 .291v.25h.25v-.25h-.25zm-.354 0v-.25h-.25v.25h.25zm0 .292v.25h.25v-.25h-.25zm-1.511 0v-.25h-.095l-.071.063.166.187zm-.419.372l-.165.187.166.147.165-.147-.166-.187zm-.42-.372l.165-.187-.07-.063H6.51v.25zm-1.403 0h-.25v.25h.25v-.25zm0-.292h.25v-.25h-.25v.25zm-.353 0h-.25v.25h.25v-.25zm0-.291h.25v-.25h-.25v.25zm-.354 0h-.25v.25h.25v-.25zm0-.948v-.25h-.25v.25h.25zm.354 0v.25h.25v-.25h-.25zm0-.292v-.25h-.25v.25h.25zm.353 0v.25h.25v-.25h-.25zm0-.364v-.25h-.25v.25h.25zm1.444 0v.25h.095l.071-.063-.165-.188zm.38-.335l.165-.187-.165-.148-.166.147.165.188zm1.929.085H7.307v.5H8.86v-.5zm.25.614v-.364h-.5v.364h.5zm.104-.25H8.86v.5h.354v-.5zm.25.542v-.292h-.5v.292h.5zm.175-.25h-.425v.5h.425v-.5zm.25 1.198v-.948h-.5v.948h.5zm-.675.25h.425v-.5h-.425v.5zm.25.041v-.291h-.5v.291h.5zm-.604.25h.354v-.5H8.86v.5zm.25.042v-.292h-.5v.292h.5zm-1.761.25h1.51v-.5H7.35v.5zm-.253.309l.419-.372-.332-.374-.419.372.332.374zm-.752-.372l.42.372.332-.374-.42-.372-.332.374zm-1.237.063H6.51v-.5H5.107v.5zm-.25-.542v.292h.5v-.292h-.5zm-.103.25h.353v-.5h-.353v.5zm-.25-.541v.291h.5v-.291h-.5zm-.104.25h.354v-.5H4.4v.5zm-.25-1.198v.948h.5v-.948h-.5zm.604-.25H4.4v.5h.354v-.5zm-.25-.042v.292h.5v-.292h-.5zm.603-.25h-.353v.5h.353v-.5zm-.25-.114v.364h.5v-.364h-.5zm1.694-.25H5.107v.5h1.444v-.5zm.166.437l.379-.335-.331-.375-.38.335.332.375zm.047-.336l.377.335.332-.373-.377-.335-.332.373z",
      fill: "#E8AA00"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.316 15.407v-.644h.751l-.75.644zm3.159 0v-.644h-.751l.75.644zm-3.159 1.166v-.644l.751.644h-.75zm3.159-.644v.644h-.751l.75-.644z",
      fill: "#C51918"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.645 14.819l.259-.34.255.34h-.514zm0 .316l.259.34.255-.34h-.514zm.259.803l-.26.339h.515l-.255-.34zm-.26.656l.26.34.255-.34h-.514z",
      fill: "#E8AA00"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.65 14.778v.146h-.148v.2h.148v.146h.52v-.146h.149v-.2h-.15v-.146H6.65zm.52 1.605v-.147h-.52v.147h-.148v.2h.148v.145h.52v-.145h.149v-.2h-.15zM5.654 15.549l.247-.341.243.34h-.49zm0 .318l.247.341.243-.34h-.49zm2.3-.659l-.247.34h.49l-.243-.34zm-.247.66l.247.34.243-.34h-.49z",
      fill: "#AF0100"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.652 15.508v.148h-.14v.204h.14v.15h.494v-.15h.143v-.204h-.143v-.148h-.494zm2.55.148v-.148h-.495v.148h-.143v.204h.143v.15h.494v-.15h.14v-.204h-.14z",
      fill: "#E8AA00"
    }
  ), /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "TM_svg__d",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 4,
      y: 17,
      width: 6,
      height: 4
    },
    /* @__PURE__ */ l.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.217 17.251l-1.772.999v1.655l1.772 1.04h1.919l1.813-1.04V18.25l-1.813-.999h-1.92z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ l.createElement("g", { mask: "url(#TM_svg__d)" }, /* @__PURE__ */ l.createElement("path", { d: "M4.47 19.096h2.762v1.823H4.47v-1.823z", fill: "#E8AA00" }), /* @__PURE__ */ l.createElement("path", { fill: "#F9E8E7", d: "M4.188 17.273h3.044v1.823H4.188z" }), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M4.895 18.336l.916-.552v.552h-.916zM10.275 17.273H7.231v1.823h3.044z",
      fill: "#E8AA00"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M9.355 18.336l-.916-.552v.552h.916zM9.992 20.919h-2.76v-1.823h2.76z",
      fill: "#F9E8E7"
    }
  ), /* @__PURE__ */ l.createElement("path", { d: "M9.285 19.856l-.916.552v-.552h.916z", fill: "#E8AA00" }), /* @__PURE__ */ l.createElement("path", { d: "M4.895 19.741l.916.552v-.552h-.916z", fill: "#FCFCFC" })), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.24 18.366h.46l.46-.145.46.145h.46v1.386h-.46l-.46.219-.46-.219h-.46v-1.386z",
      fill: "#C51918"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.799 17.538h.25v.282h.1v.2h-.1v.108h-.25v-.59zm-2.512.875h-.25v.59h.25v-.108h.103v-.2h-.103v-.282zm.354 0h-.25v.59h.25v-.59zm-.354.73h-.25v.59h.25v-.108h.103v-.2h-.103v-.282zm.104 0h.25v.59h-.25v-.59zm3.54-.73h.25v.282h.102v.2h-.101v.108h-.25v-.59zm.604 0h-.25v.59h.25v-.59zm-.353.73h-.25v.589h.25v-.107h.1v-.2h-.1v-.282zm.103 0h.25v.59h-.25v-.59zm-.883-1.605h-.25v.59h.25v-.59zm-2.052 0H6.1v.59h.25v-.108h.1v-.2h-.1v-.282zm.103 0h.25v.59h-.25v-.59zm1.346 2.48h.25v.282h.1v.2h-.1v.107h-.25v-.589zm.603 0h-.25v.59h.25v-.59zm-2.052 0H6.1v.589h.25V20.5h.1v-.2h-.1v-.282zm.103 0h.25v.59h-.25v-.59z",
      fill: "#C9343F"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.026 18.666h.07v-.198h-.353v.227H6.45v.324h.271v-.073h-.2v-.179h.24l.363.314-.362.313h-.241v-.18h.2v-.072h-.27v.325h.29v.226h.354v-.198h-.07v.125h-.213v-.175l.368-.318.368.318v.175h-.212v-.125h-.07v.198h.353v-.226h.292v-.325H7.64v.073h.2v.179H7.6l-.362-.313.362-.314h.24v.18h-.2v.072h.272v-.324H7.62v-.227h-.354v.198h.071v-.125h.212v.175l-.368.318-.368-.318v-.175h.213v.125z",
      fill: "#fff"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.584 4.8H6.338v4h1.246v-4zm-2.805.846h.78v2.153h-.78V5.646zm3.662 0h.78v2.153h-.78V5.646z",
      fill: "#E8AA00"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.338 5.107h-.78v3.077h.78V5.107zm-1.559.846H4v1.462h.78V5.953zm4.442 0H10v1.462h-.78V5.953zm-.858-.846h-.779v3.077h.78V5.107z",
      fill: "#389F5D"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.182 5.492c0 .128-.104.231-.234.231a.232.232 0 01-.233-.23c0-.128.104-.231.233-.231.13 0 .234.103.234.23zm-1.558.77c0 .127-.105.23-.234.23a.232.232 0 01-.234-.23c0-.127.105-.23.234-.23.13 0 .234.103.234.23zm0 .846c0 .127-.105.23-.234.23a.232.232 0 01-.234-.23c0-.128.105-.23.234-.23.13 0 .234.102.234.23zm1.324.923c.13 0 .234-.103.234-.23a.232.232 0 00-.234-.232.232.232 0 00-.233.231c0 .128.104.231.233.231zm3.663-1.538c.129 0 .233-.104.233-.231a.232.232 0 00-.233-.23.232.232 0 00-.234.23c0 .127.105.23.234.23zm.234.615c0 .127-.105.23-.234.23a.232.232 0 01-.234-.23c0-.128.105-.23.234-.23s.234.102.234.23zm-1.871.923c.13 0 .234-.103.234-.23a.232.232 0 00-.234-.232.232.232 0 00-.234.231c0 .128.105.23.234.23zm.234-2.539c0 .128-.105.231-.234.231a.232.232 0 01-.234-.23c0-.128.105-.231.234-.231.13 0 .234.103.234.23z",
      fill: "#E1E5E8"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.196 5.185c0 .127-.105.23-.234.23a.232.232 0 01-.233-.23c0-.128.104-.23.233-.23.13 0 .234.102.234.23zm-1.793.846c0 .127-.105.23-.234.23a.232.232 0 01-.233-.23c0-.128.104-.231.233-.231.13 0 .234.103.234.23zm1.56 2.692c.128 0 .233-.103.233-.23a.232.232 0 00-.234-.231.232.232 0 00-.233.23c0 .128.104.231.233.231zm2.102-2.692c0 .127-.104.23-.234.23a.232.232 0 01-.233-.23c0-.128.104-.231.233-.231.13 0 .234.103.234.23zM5.17 7.646c.13 0 .234-.103.234-.23a.232.232 0 00-.234-.231.232.232 0 00-.233.23c0 .128.104.231.233.231zm3.896-.23c0 .127-.104.23-.234.23a.232.232 0 01-.233-.23c0-.128.104-.231.233-.231.13 0 .234.103.234.23z",
      fill: "#C51918"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.607 6.391l.759-.685h1.232l.864.786h1.15V6.8H8.492v.016l-.895.91H6.366l-.759-.821V6.8H4.312v-.308h1.295v-.1z",
      fill: "#C51918"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.005 6.27l.374.38-.387.366-.386-.367.373-.378.013-.012.013.012zm.072.908l.044-.04-.044-.042.383-.364.4.406-.18.19h-.106l-.2.125-.297-.275zm-.085.079l-.369.341-.246-.155h-.124l-.29-.307.477-.484-.481-.455.315-.306.115.09.165-.167-.05-.05.084-.081.404.41.404-.41.084.08-.05.05.165.168.115-.09.315.306-.48.455.477.484-.291.307h-.123l-.247.155-.369-.341zm.206-.956l.005-.005-.116-.108-.009-.008.288-.266.22.222.116-.091.155.15-.394.375-.265-.269zm-.247.836l-.341.316-.2-.125h-.106l-.18-.19.4-.406.427.405zm-.824-.941l.394.374.385-.39-.288-.266-.22.222-.115-.091-.156.15zM4.448 21.442c-.209-.266-.35-.445-.387-.442-.117.009-.226 1.244 1.29 2.184 0 0 .224.124.355 0 .13-.125 0-.308 0-.308-.49-.46-.948-1.042-1.258-1.434zm5.104 0c.209-.266.35-.445.387-.442.117.009.226 1.244-1.29 2.184 0 0-.1.055-.205.055.275.012.655-.034.997-.136 0 0-.906.365-1.445.203a.95.95 0 00-.165-.053 1.553 1.553 0 00-.5-.02c.079.037.171.079.279.123v.044a2.42 2.42 0 00-.566-.14 2.42 2.42 0 00-.566.14v-.044c.108-.044.2-.086.28-.123a1.553 1.553 0 00-.501.02.95.95 0 00-.165.053c-.539.162-1.446-.203-1.446-.203.499.148 1.076.178 1.297.083.07-.03.145-.054.223-.072.22-.05.434-.05.688-.022l.093.01.007.001a.72.72 0 00.04.004c.015 0 .032.003.05.007a.222.222 0 01.05-.007.72.72 0 00.04-.004h.007l.093-.011c.254-.028.468-.028.688.022.078.018.153.042.223.072a.847.847 0 00.27.052.201.201 0 01-.12-.054c-.131-.125 0-.308 0-.308.49-.46.947-1.042 1.257-1.434z",
      fill: "#E8AA00"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.764 9.977L4.512 11.08v1.05l1.094 1.1h2.235l1.232-1.173v-.895L7.841 9.977H5.764z",
      fill: "#389F5D"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.193 10.094H5.91v.219h.283v-.22zm0 2.86H5.91v.219h.283v-.219zm.424 0H6.9v.219h-.283v-.219zm.283-2.86h-.283v.219H6.9v-.22zm.426 2.86h.283v.219h-.283v-.219zm.283-2.86h-.283v.219h.283v-.22z",
      fill: "#C51918"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.554 10.037h-.288v.219h.288v-.219zm0 2.917h-.288v.219h.288v-.219zm.432-2.917h.289v.219h-.289v-.219zm.289 2.917h-.289v.219h.289v-.219z",
      fill: "#E8AA00"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.914 9.842h3.78v.584h.541v2.415h-.541v.499h-3.78v-.5h-.588v-2.414h.588v-.584zm.213.803h-.588v1.977h.588v.5h3.355v-.5h.541v-1.977h-.541v-.585H5.127v.585z",
      fill: "#750100"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.407 9.6h-.354v.364h.354V9.6zm.566 0h-.354v.364h.354V9.6zm.213 0h.354v.364h-.354V9.6zm-.78 3.645h-.353v.365h.354v-.365zm.213 0h.354v.365H6.62v-.365zm.92 0h-.353v.365h.354v-.365zm-3.545-.806v-.354h.365v.353h-.365zm0-.938v.354h.365V11.5h-.365zm0-.23v-.354h.365v.354h-.365zm5.098.813v.354h.364v-.354h-.364zm0-.23v-.353h.364v.354h-.364zm0-.936v.354h.364v-.354h-.364z",
      fill: "#389F5D"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.779 10.284l-.611.531v1.719l.507.358H7.87l.506-.358v-1.719l-.57-.53H5.777z",
      fill: "#C51918"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.803 10.996l-.737.63h.737v-.63z",
      fill: "#E1E5E8"
    }
  ), /* @__PURE__ */ l.createElement("path", { d: "M6.803 12.197l-.737-.63h.737v.63z", fill: "#E8AA00" }), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.738 10.996l.737.63h-.737v-.63z",
      fill: "#E8AA00"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.772 11.796a.223.223 0 100-.446.223.223 0 000 .446z",
      fill: "#29AE66"
    }
  ), /* @__PURE__ */ l.createElement("path", { d: "M6.738 12.197l.737-.63h-.737v.63z", fill: "#E1E5E8" }), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.204 11.35h-.638v.204h.638v-.204zm0 .372h-.638v.204h.638v-.204zm3.185-.372h.637v.204h-.637v-.204zm.637.372h-.637v.204h.637v-.204z",
      fill: "#C51918"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.133 11.13h-.567v.224h.567v-.223zm0 .373h-.567v.223h.567v-.223zm-.567.372h.567v.223h-.567v-.223zm4.389-.744h-.566v.223h.566v-.223zm-.566.372h.566v.223h-.566v-.223zm.566.372h-.566v.223h.566v-.223zM9.984 1.59l-.002.406H7.024l-.002 1.839h-.928c-.162 0-.606-.311-.606-.311h-.753l-.348-.355v-.357l-.373-.444.002-.405h2.958L6.976.124h.928c.162 0 .606.311.606.311h.753l.348.355v.357l.373.444z",
      fill: "#E8AA00"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.014 1.59l.002.406h2.958l.002 1.839h.928c.162 0 .606-.311.606-.311h.753l.348-.355v-.357l.373-.444-.002-.405H7.024L7.022.124h-.928c-.162 0-.606.311-.606.311h-.753L4.387.79v.357l-.373.444z",
      fill: "#E1E5E8"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.003.685L5.971.53l.638-.147c.077-.037.21-.142.393-.314l.085.097.015-.017c.183.172.316.277.393.314l.638.147L8.1.765 7.748.693l.033.03a.44.44 0 00-.079.063l-.15-.022.014-.05-.038-.006a1.699 1.699 0 00-.092.22l-.15-.043.06-.29L7.01.278 6.773.5c.03.027.058.057.088.092-.025.01-.05.018-.072.025l-.01.003.038.185-.15.044a2.242 2.242 0 00-.055-.145l-.013.002a.44.44 0 00-.08-.064l.043-.038a.37.37 0 00-.02-.03l-.539.111zm.027.573l.085-.134-.44-.296.048-.067-.126-.095-.054.075-.175-.118-.085.134.168.113-.035.049.126.095.04-.056.448.3zm-.545.16l.085-.134-.441-.296.049-.068-.126-.095-.054.076-.175-.117-.085.133.168.113-.035.048.126.095.04-.056.448.301zm-.235.48l.085-.134-.44-.295.049-.069-.126-.094-.054.075-.175-.117-.085.134.167.112-.034.049.126.094.04-.055.447.3zm.007.384l-.085-.134-.448.301-.04-.055-.125.094.034.049-.167.112.085.134.175-.117.054.075.125-.094-.049-.069.441-.296zm.15.346l.085.134-.441.296.049.068-.126.095-.054-.076-.175.117-.085-.134.168-.112-.035-.048.126-.095.04.056.448-.301zm.545.16l.085.134-.441.296.049.068-.126.095-.054-.076-.175.118-.085-.134.168-.113-.035-.048.126-.095.04.056.448-.3zm.831.765a1.399 1.399 0 00-.072-.025l-.03-.007.058-.279-.149-.044a1.205 1.205 0 01-.125.275l-.54-.112-.032.157.615.141v.001l.089.06.012-.008c.077.054.183.143.315.266l.05-.056.05.057c.183-.172.316-.277.392-.314l.021-.005a.62.62 0 00.081.06l.09-.06-.01-.03.01-.01.447-.102-.033-.156-.54.111a1.206 1.206 0 01-.125-.275l-.149.044.06.29-.294.277-.228-.214.037-.042zm1.907-1.27l.085-.135.448.301.04-.055.126.094-.035.049.167.112-.085.134-.174-.117-.054.075-.126-.094.049-.069-.441-.296zm-.233.479l.086-.134.448.3.04-.055.125.095-.034.048.167.112-.085.134-.175-.117-.054.076-.125-.095.049-.068-.442-.296zm-.546.16l.085-.134.448.3.04-.055.125.095-.034.048.167.113-.085.134-.175-.118-.054.076-.125-.095.049-.068-.441-.296zm.857-1.077l.085.134.449-.301.04.055.125-.094-.035-.049.168-.112-.086-.134-.174.117-.054-.075-.126.094.05.069-.442.296zm-.232-.48l.085.133.447-.3.039.055.125-.095-.034-.047.17-.113-.086-.134-.176.118-.055-.077L8.926 1l.05.07-.44.294zm-.547-.161l.085.134.448-.3.04.056.126-.095L8.652.95 8.82.837 8.735.703 8.56.821 8.506.746 8.381.84l.048.067-.44.296z",
      fill: "#C51918"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.208 1.153L7.09.685v1.28h2.181l-.52.374v.49H7.93l-.883.468v-1.28h-2.18l.52-.375v-.49h.822z",
      fill: "#C51918"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.929 1.153L7.046.685v1.28h-2.18l.52.374v.49h.822l.882.468v-1.28h2.181l-.52-.375v-.49H7.93z",
      fill: "#29AE66"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.78 1.485l.143-.284.367.196.101-.15.257.182-.08.117 1.085.58.066-.1.257.182-.045.067.117.063-.144.283-.151-.08-.123.182-.257-.181.101-.15-1.084-.58-.089.132-.256-.182.067-.1-.333-.177z",
      fill: "#29AE66"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.09 1.407l-.163-.273-.353.221-.11-.142-.244.199.087.111-1.041.655-.074-.095-.243.199.05.064-.113.07.164.273.145-.091.135.174.243-.2-.11-.142 1.04-.654.098.126.244-.2-.074-.094.32-.2z",
      fill: "#C51918"
    }
  )), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.073 2s2.33 5.522.26 7.867C17.263 12.21 12 11.759 12 11.759s6.756 3.052 9.7-1.15C24.644 6.407 19.073 2 19.073 2z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.845 5.248l-.616.434.217-.727-.598-.46.75-.015.247-.717.247.717.75.016-.598.459.218.727-.617-.434zm.12 2.005l-.617.434.217-.727-.598-.46.75-.015.247-.717.247.717.751.016-.599.459.218.727-.617-.434zm-2.492.59l.616-.435.617.434-.218-.727.599-.459-.751-.015-.247-.718-.246.718-.751.015.598.46-.217.726zm2.491 1.514l-.616.433.217-.727-.598-.459.75-.015.247-.718.247.718.751.015-.599.46.218.726-.617-.433zm1.42-2.282l.617-.434.617.434-.218-.728.599-.459-.751-.015L17 5.155l-.246.718-.751.015.598.46-.217.727z",
      fill: "#F7FCFF"
    }
  )))
), h = v;
export {
  h as default
};
